import Login from "../components/Authorization/Login";

const login = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
];

export default login;



// WEBPACK FOOTER //
// ./src/router/login.js